<div class="tree-table-container">
  <table mat-table [dataSource]="dataSource" multiTemplateDataRows class="mat-elevation-z1 full-width">

    <!-- Column Headers (Sticky Header) -->
    <ng-container matColumnDef="state">
      <th mat-header-cell *matHeaderCellDef class="header-col header-state" [style.width]="getColumnWidth('state')">
        State
        <div class="resize-handle" (mousedown)="onResizeStart($event, 'state')"></div>
      </th>
    </ng-container>

    <ng-container matColumnDef="utility">
      <th mat-header-cell *matHeaderCellDef class="header-col header-utility" [style.width]="getColumnWidth('utility')">
        Utility
        <!-- Use $event, 'utility' if utility is not available use $event, 'company'-->
        <div class="resize-handle" (mousedown)="onResizeStart($event, 'company')"></div>

      </th>
    </ng-container>

    <ng-container matColumnDef="proceeding">
      <th mat-header-cell *matHeaderCellDef class="header-col header-proceeding" [style.width]="getColumnWidth('proceeding')">
        Proceeding Number
        <div class="resize-handle" (mousedown)="onResizeStart($event, 'proceeding')"></div>
      </th>
    </ng-container>

    <ng-container matColumnDef="title">
      <th mat-header-cell *matHeaderCellDef class="header-col header-title" [style.width]="getColumnWidth('title')">
        Title
        <div class="resize-handle" (mousedown)="onResizeStart($event, 'title')"></div>
        <!-- No resize handle on last column -->
      </th>
    </ng-container>

    <!-- Header row -->
    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>

    <!-- Node Row Definition -->
    <ng-container matColumnDef="nodeRow">
      <td mat-cell *matCellDef="let node" [attr.colspan]="displayedColumns.length" [class]="'node-row level-' + node.level">
        <div class="node-row-content" [style.padding-left.%]="node.level * 1.5 + '%'">
          <mat-checkbox (click)="$event.stopPropagation()"
                        (change)="toggleNodeSelection(node)"
                        [checked]="isNodeSelected(node)"
                        [indeterminate]="isNodePartiallySelected(node)"
                        class="node-checkbox">
          </mat-checkbox>
          <div tabindex="0" (keyup.enter)="toggleNode(node)" class="node-info" (click)="toggleNode(node)">
            <mat-icon class="node-icon">
              {{ node.expanded ? 'expand_more' : 'chevron_right' }}
            </mat-icon>
            <strong>{{ getNodeLabel(node) }} ({{ getNodeCount(node) }})</strong>
          </div>
        </div>
      </td>
    </ng-container>

    <!-- Expanded Detail Definition -->
    <ng-container matColumnDef="expandedDetail">
      <td mat-cell *matCellDef="let node" [attr.colspan]="displayedColumns.length" class="expanded-detail-cell">
        <div class="detail-container" [@detailExpand]="node.expanded ? 'expanded' : 'collapsed'">
          <ng-container *ngIf="node.expanded">
            <ng-container *ngFor="let child of node.children">
              <app-tree-node [node]="child"
                             [selection]="selection"
                             [columnWidths]="columnWidths"
                             (nodeToggle)="toggleNode($event)"
                             (nodeSelectionToggle)="toggleNodeSelection($event)"
                             (docSelectionToggle)="toggleSelection($event)">
              </app-tree-node>
            </ng-container>
          </ng-container>
        </div>
      </td>
    </ng-container>

    <!-- Rows -->
    <tr mat-row *matRowDef="let row; columns: ['nodeRow'];" class="node-row-element"></tr>
    <tr mat-row *matRowDef="let row; columns: ['expandedDetail'];" class="detail-row"></tr>
  </table>
</div>
